import Vue from 'vue'

export function setGrupos(state, grupos) {
    state.grupos = grupos;
}

export function setGrupoSelec(state, grupo) {
    state.grupoSelec = grupo;
}

export function setOrdenGrupo(state, ordenGrupo) {
    state.ordenGrupo = ordenGrupo;
}



export function actListGrupos(state, grupo) {
    if (grupo !== null) {
        const index = state.grupos.findIndex(r => r.id === grupo.id)
        if (index != -1) {
            state.grupos[index].nombre = grupo.nombre;  
            state.grupos[index].descripcion = grupo.descripcion;  
            state.grupos[index].responsable = grupo.responsable;  
            state.grupos[index].telefono = grupo.telefono;  
            state.grupos[index].email = grupo.email;  
            state.grupos[index].grupo_id = grupo.grupo_id;  
        }
    }
}

export function actDeleteListGrupos(state, id) {
    if (id != null) {
        const index = state.grupos.findIndex(r => r.id === id)
        if (index != -1) {
            state.grupos.splice(index, 1)
        }
    }
}



export function actListOrigenesFromGrupos(state, origen) {
    if (origen !== null) {
        for (let i = 0; i < state.grupos.length; i++) {
            const index = state.grupos[i].origenes.findIndex(r => r.id === origen.id)
            if (index != -1) {
                state.grupos[i].origenes[index].nombre = origen.nombre;
                state.grupos[i].origenes[index].nombre_fiscal = origen.nombre_fiscal;
                state.grupos[i].origenes[index].cif = origen.cif;
                state.grupos[i].origenes[index].descripcion = origen.descripcion;
                state.grupos[i].origenes[index].telefono = origen.telefono;
                state.grupos[i].origenes[index].telefono_2 = origen.telefono_2;
                state.grupos[i].origenes[index].email = origen.email;
                state.grupos[i].origenes[index].responsable = origen.responsable;
                state.grupos[i].origenes[index].identificador = origen.identificador;
                state.grupos[i].origenes[index].cod_proveedor = origen.cod_proveedor;
                state.grupos[i].origenes[index].comision = origen.comision;
                state.grupos[i].origenes[index].direccion = origen.direccion;
                state.grupos[i].origenes[index].cod_postal = origen.cod_postal;
                state.grupos[i].origenes[index].poblacion = origen.poblacion;
                state.grupos[i].origenes[index].provincia = origen.provincia;
                state.grupos[i].origenes[index].pais = origen.pais;
                state.grupos[i].origenes[index].direccion_fiscal = origen.direccion_fiscal;
                state.grupos[i].origenes[index].cod_postal_fiscal = origen.cod_postal_fiscal;
                state.grupos[i].origenes[index].poblacion_fiscal = origen.poblacion_fiscal;
                state.grupos[i].origenes[index].provincia_fiscal = origen.provincia_fiscal;
                state.grupos[i].origenes[index].pais_fiscal = origen.pais_fiscal;
                state.grupos[i].origenes[index].observacion = origen.observacion;
                state.grupos[i].origenes[index].mensaje = origen.mensaje;
                state.grupos[i].origenes[index].grupo_id = origen.grupo_id;
                state.grupos[i].origenes[index].caminos_permitidos = origen.caminos_permitidos;
                Vue.set(state.grupos[i].origenes[index], 'is_active', origen.is_active);
                Vue.set(state.grupos[i].origenes[index], 'users', origen.users || []);
            } 
        }
    }
}

export function actDeleteListOrigenesFromGrupos(state, id) {
    if (id != null) {
        for (let i = 0; i < state.grupos.length; i++) {
            const index = state.grupos[i].origenes.findIndex(r => r.id === id)
            if (index != -1) {
                state.grupos[i].origenes.splice(index, 1)
            }
        }
    }
}

export function actUserInOrigenesFromGrupos(state, payload) {
    if (!payload || payload.user_id == null) {
        return;
    }

    for (let i = 0; i < state.grupos.length; i++) {
        const origenes = state.grupos[i].origenes || [];

        for (let j = 0; j < origenes.length; j++) {
            const usuarios = origenes[j].users;
            if (!Array.isArray(usuarios)) {
                continue;
            }

            const userIndex = usuarios.findIndex((user) => String(user.id) === String(payload.user_id));
            if (userIndex !== -1) {
                state.grupos[i].origenes[j].users[userIndex] = {
                    ...state.grupos[i].origenes[j].users[userIndex],
                    ...payload.user,
                };
                return;
            }
        }
    }
}
